import fetch from 'isomorphic-fetch'
import { isEmpty, mergeDeepRight } from 'ramda'
import { toastr } from 'react-redux-toastr'
import { push } from 'react-router-redux'
import { logout } from '../actions/authActions'
import { getAccessToken } from '../utils/mainUtils'
import { logoutUser } from './authApi'

const authHeader = auth => ({
    headers: { Authorization: `Bearer ${getAccessToken(auth)}` }
})

export const securedFetch = (url, auth, options) => fetch(url, mergeDeepRight(authHeader(auth.token), options))

export const formatErrorMessage = res => `[${res.status}]: ${res.statusText} (${res.url})`

// Сhecking whether the content type is correct
// https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch#Headers
export const isJsonResponse = response => {
    const contentType = response.headers.get('content-type')
    return contentType && (contentType.includes('application/json') || contentType.includes('application/hal+json'))
}

export const handleResponse = response => {
    if (response.ok) {
        if (isJsonResponse(response)) {
            return response.json()
        } else {
            return response.text()
        }
    } else {
        const error = new Error(formatErrorMessage(response))
        error.response = response
        throw error
    }
}

export const handleTokenResponse = response => {
    if (response.ok && isJsonResponse(response)) {
        return response.json()
    } else {
        return Promise.reject({ message: 'Ошибка обновления токена' })
    }
}

export const handleError = (dispatch, errAction, errToastMessage, errToastDescription) => err => {
    errToastMessage && toastr.error(errToastMessage, errToastDescription, { timeOut: 5000 })
    dispatch(errAction(err))
}

export const handleErrorWithMessage = (dispatch, errAction) => err => {
    if (isJsonResponse(err.response)) {
        err.response.json().then(errResponse => toastr.error('Ошибка!', errResponse.error, { timeOut: 5000 }))
    } else {
        toastr.error('Что-то пошло не так!', '', { timeOut: 10000 })
    }
    dispatch(errAction())
}

export const handleTokenError = (dispatch, errAction, errToastMessage, errToastDescription) => err => {
    handleError(dispatch, errAction, errToastMessage, errToastDescription)(err)

    // action doesn't go to the errorMiddleware, so we logout here
    logoutUser()(dispatch)
    throw err
}

export const handleAuthError = (dispatch, errAction, errToastMessage, errToastDescription) => err => {
    if (err.response.status === 400) {
        toastr.error('Неправильный логин или пароль!')
        dispatch(errAction(err))
    } else {
        errToastMessage && toastr.error(errToastMessage, errToastDescription, { timeOut: 5000 })
        dispatch(errAction(err))
    }
}

export const showImportCategoriesToastr = json => {
    if (isEmpty(json)) {
        toastr.success(`Ничего нового не проимпортировано`)
    } else {
        json.forEach(category => {
            toastr.success(`Проимпортировано ${category.remoteId}: ${category.remoteName}`)
        })
    }
    return json
}

export const showImportRatesToastr = json => {
    if (isEmpty(json)) {
        toastr.success(`Ничего нового не проимпортировано`)
    } else {
        json.forEach(rate => {
            toastr.success(`Проимпортировано ${rate.remoteId}: ${rate.remoteName}`)
        })
    }
    return json
}

export const showImportApartmentsToastr = json => {
    if (isEmpty(json)) {
        toastr.success(`Ничего нового не проимпортировано`)
    } else {
        json.forEach(apartment => {
            toastr.success(`Проимпортировано ${apartment.remoteApartmentsId}: ${apartment.remoteApartmentsName}`)
        })
    }
    return json
}

export const errorActions = {
    unauthorized: [logout, push('/login')]
}



// WEBPACK FOOTER //
// ./src/api/apiUtils.js